//Component imports
import {
  GetActiveRoundsForBase,
  GetBaseSummary,
  GetCrewTracBST,
  GetCrewTracVAC,
  GetEntitleReport,
  GetExcelSummary,
  GetOpenSlots,
  PutExtendRound,
  Rounds,
} from '../config/endpoints-config';
import GeneralService from './GeneralService';

export default class ReportsService extends GeneralService {
  async getEntitleReport(year: number) {
    let result = this.getFileWithParams(GetEntitleReport(year), null);
    return result;
  }

  async getCrewTracVAC(startDate: Date, endDate: Date) {
    let result = this.getFileWithParams(GetCrewTracVAC(startDate, endDate), null);
    return result;
  }

  async getCrewTracBST(startDate: Date, endDate: Date) {
    let result = this.getFileWithParams(GetCrewTracBST(startDate, endDate), null);
    return result;
  }

  async getOpenSlots(year: number) {
    let result = this.getFileWithParams(GetOpenSlots(year), null);
    return result;
  }

  async getExcelSummary(year: number) {
    let result = this.getFileWithParams(GetExcelSummary(year), null);
    return result;
  }

  async getBaseSummary(year: number, baseid: number) {
    let result = this.getFileWithParams(GetBaseSummary(year, baseid), null);
    return result;
  }
}
